import { render } from "./Container.vue?vue&type=template&id=173766dc&lang=pug"
import script from "./Container.vue?vue&type=script&setup=true&lang=js"
export * from "./Container.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__